import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-400 py-12 mt-12">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-white font-bold text-lg mb-4">osmolaridade.com.br</h3>
            <p className="text-sm">
              Ferramenta educacional e de suporte à decisão clínica para cálculo de osmolaridade sérica estimada e avaliação do gap osmolar.
            </p>
          </div>
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Acesso Rápido</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="#calculadora" className="hover:text-white transition-colors">Calculadora</a></li>
              <li><a href="#como-calcular" className="hover:text-white transition-colors">Sobre o Cálculo</a></li>
              <li><a href="#conteudo" className="hover:text-white transition-colors">Conceitos</a></li>
            </ul>
          </div>
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Aviso Legal</h3>
            <p className="text-xs leading-relaxed">
              As informações fornecidas não substituem o julgamento clínico. A ferramenta não é um dispositivo médico e todos os cálculos devem ser verificados de forma independente antes do uso clínico. A avaliação de pacientes requer contexto laboratorial completo.
            </p>
          </div>
        </div>
        <div className="border-t border-slate-800 pt-8 text-sm text-center">
          <p>&copy; {new Date().getFullYear()} osmolaridade.com.br. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
